<template>
    <div class="input-field" style="width: 100%">
        <div class="select-wrapper" style="width: 100%">
            <template  v-if="elongating">
            <div class="select-dropdown dropdown-opener elongating" :data-target="'dropdownselector'+uid" v-show="!disabled">
                <p v-for="ritem in ritems">{{ritem}}</p>
            </div>
            <div class="elongating" v-show="disabled">
                <p v-for="ritem in ritems">{{ritem}}</p>
            </div>
            </template>
            <template v-else>
                <input type="text" readonly="true" :value="labels" v-show="disabled" />
                <div class="dropdown-opener" :data-target="'dropdownselector'+uid" v-show="!disabled">
                    <input class="select-dropdown" type="text" readonly="true" :value="labels" v-if="!disabled"/>
                    <i class="material-icons dp6 " style="top: 5px;position: absolute;right: 5px;z-index: 999;">expand_more</i>
                </div>
            </template>
        </div>
        <ul :id="'dropdownselector'+uid" class='dropdown-content select-dropdown multiple-select-dropdown'>
            <li class='searchterm' style="position: sticky; top: 0px;">
                <p><input v-model="searchterm" /></p>
            </li>
            <li v-for="item in filteredItems" v-if="groupitems == undefined">
                <span>
                    <label>
                        <input :value="item.value" v-model="selectionsLocal" type="checkbox" checked="checked" v-if="!singlemode" />
                        <template v-if="singlemode">
                            <p v-on:click="selectedItem(item)">{{item.name}}</p>
                        </template>
                        <span style="width: 100%;" v-if="!singlemode">{{item.name}}</span>
                    </label>
                </span>
            </li>
            <template v-for="group in filteredGroups" v-if="groupitems != undefined">
                <label>
                    <span v-html="boldString(group.name, searchterm)" />
                </label>
                <ul>
                    <li v-for="item in group.items" tabindex="-1">
                        <span>
                            <label>
                                <input :value="item.value" v-model="selectionsLocal" type="checkbox" checked="checked" v-if="!singlemode" />
                                <template v-if="singlemode">
                                    <p v-on:click="selectedItem(item)" v-html="boldString(item.name, searchterm)">{{item.name}}</p>
                                </template>
                                <span style="width: 100%;" v-if="!singlemode">{{item.name}}</span>
                            </label>
                        </span>
                    </li>
                </ul>
            </template>
        </ul>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    name: 'selector',
    data: function() {
        return {
            searchterm: "",
            uid: _.uniqueId("selector")
        }
    },
    props: {
        selections: {
            type: [Array, Number],
            default () {
                return []
            }
        },
        items: Array,
        identifier: String,
        disabled: {
            type: Boolean,
            default () {
                return false
            }
        },
        elongating: Boolean,
        singlemode: {
            type: Boolean,
            default(){
                return false;
            }
        },
        groupitems: String,
        recommendations: Array,
        placeholder: {
            type: String,
            default(){
                return this.$t('menu.buttons.select_placeholder') ;
            }
        }
    },
    model: {
        prop: 'selections',
        event: 'listchange'
    },
    mounted: function() {
        var elemss = this.$el.querySelectorAll('.dropdown-opener');
        var that = this;
        this.instance = M.Dropdown.init(elemss, { closeOnClick: false, onCloseStart: function(){
            that.searchterm = "";
        } });
    },
    methods: {
        selectedItem(item) {
            this.selectionsLocal = item.value;
            this.instance[0].close();
        },
        boldString(str, find) {
            var re = new RegExp(find, 'gi');
            if (find.length > 0 && str.match(re) && str.match(re).length > 0) {
                return str.replace(re, '<b>' + str.match(re)[0] + '</b>');
            } else {
                return str;
            }
        }
    },
    computed: {
        selectionsLocal: {
            get: function() {
                return this.selections
            },
            set: function(value) {
                this.$emit('listchange', value)
            }
        },
        labelGroups(){
            var keys = [];
            var names = [];
            if (this.groupitems == undefined) {
                for (var item of this.items) {
                    keys.push([_.isObject(item) ? item.value : item]);
                    names.push([_.isObject(item) ? item.name : item]);
                }
                var lbs = _.zipObject(keys, names);
            }else{
                if (_.isUndefined(this.items) == false) {
                    for (var i = this.items.length - 1; i >= 0; i--) {
                        lbs = _.extend(lbs, _.zipObject(this.items[i][this.groupitems].map(item => [item.id]), this.items[i][this.groupitems].map(item => [item.name])))
                    }
                }
            }
            return lbs;
        },
        ritems() {
            var lbs = this.labelGroups;
            if (_.isUndefined(this.selectionsLocal)) {
                return [this.placeholder]
            } else if (this.singlemode) {
                console.log(lbs[this.selectionsLocal]);
                var item = _.first(lbs[this.selectionsLocal]);
                if (_.isString(item)) { return [item]; } else { return [this.placeholder]; }
            } else {
                var outlist = _.flatten(this.selectionsLocal.map(item => lbs[item]))
                if(_.isEmpty(outlist)){
                    return [this.placeholder];
                }else{
                    return outlist;
                }
            }
        },

        labels() {
            return this.ritems.join(", ");
        },

        filteredGroups: function() {
            var that = this;
            var imts = _(this.items).map(function(item) {
                if (item instanceof Object) {
                    if (_.isUndefined(that.recommendations)) {
                        if ((item.name || "").toLowerCase().indexOf((that.searchterm || "").toLowerCase()) !== -1) {
                            return {
                                name: item.name,
                                items: _.map(item[that.groupitems], function(subitem) {
                                    return {
                                        value: subitem.id,
                                        name: subitem.name
                                    }
                                })
                            }
                        } else {
                            var out = _.compact(_.map(item[that.groupitems], function(subitem) {
                                if ((subitem.name || "").toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1) {
                                    return {
                                        value: subitem.id,
                                        name: subitem.name
                                    }
                                }
                            }))
                            if (out.length > 0) {
                                return {
                                    name: item.name,
                                    items: out
                                }
                            }
                        }
                    } else {
                        var out = _(item[that.groupitems]).map(function(subitem) {
                            var hasreco = false;
                            if (_.isUndefined(that.recommendations) == false) {
                                if (that.recommendations.length > 0) {
                                    hasreco = true;
                                }
                            }
                            if (hasreco) {
                                var inRecos = that.recommendations.indexOf(subitem.id) > -1;
                                if ((subitem.name || "").toLowerCase().indexOf(that.searchterm.toLowerCase()) > -1 && inRecos) {
                                    return {
                                        value: subitem.id,
                                        name: subitem.name
                                    }
                                }
                            } else {
                                if ((subitem.name || "").toLowerCase().indexOf(that.searchterm.toLowerCase()) > -1) {
                                    return {
                                        value: subitem.id,
                                        name: subitem.name
                                    }
                                }
                            }
                        }).compact().value();
                        if (out.length > 0) {
                            return {
                                name: item.name,
                                items: out
                            }
                        }
                    }
                }
                if (item instanceof String) {
                    if (item.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1) {
                        return {name: item, value: item};
                    }
                }
            }).compact().value();
            return imts;

        },
        filteredItems: function() {
            if (this.items.length == 0) {
                return [];
            } else {
                return _.map(this.items.filter(item => {
                    if (item instanceof Object) {
                        var iname = ""
                        if (_.isNull(item.name) == false) iname = item.name.toLowerCase();
                        if (this.groupitems) {
                            iname = iname + _.map(item[this.groupitems], 'name').join(" ").toLowerCase();
                        }
                        return iname.indexOf(this.searchterm.toLowerCase()) > -1;
                    } else {
                        return item.toLowerCase().indexOf(this.searchterm.toLowerCase()) > -1;
                    }
                }), item => {
                    if (item instanceof Object) {
                        return item;
                    }
                    if (_.isString(item)) {
                        return {
                            name: item,
                            value: item
                        }
                    }
                });
            }
        },
    }
}
</script>
<style scoped>
.searchterm {
    min-height: initial;
}

.searchterm input {
    margin: 0px;
    width: 95%;
}

.input-field {
    width: 100% !important;
}

.select-wrapper {
    width: 100% !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
}

[type="checkbox"]:checked+span:not(.lever):before {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
}

.dropdown-content p {
    margin-top: 0px;
    margin-bottom: 0px;
}

.elongating {
    border: 1px solid #9e9e9e;
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 15px;
}
</style>